import React from 'react';
import Tooltip from '../../../../ui/Tooltip';
import { PaymentModel } from '../../../models/payment.model';
import {
  getServiceFeeStatus,
  ServiceFeeStatus
} from '../../../services/helpers/service-fee.helper';

export interface ServiceFeeBadgeProps {
  data: {
    payments?: PaymentModel[];
  };
  className?: string;
}

/**
 * Flags a reservation whose guest is not being charged a service fee. Charging one is
 * the norm, so an included fee gets no badge — only the exception is called out.
 * Renders nothing until the reservation has a payment to judge by.
 */
export const ServiceFeeBadge: React.FC<ServiceFeeBadgeProps> = ({ data, className }) => {
  if (getServiceFeeStatus(data.payments) !== ServiceFeeStatus.WAIVED) return null;

  return (
    <Tooltip title="None of the payment links on this reservation charge a service fee">
      <div
        className={`bg-gray-50 text-gray-600 border-gray-200 border px-2 py-1 rounded-md text-xl font-semibold whitespace-nowrap cursor-default ${
          className || ''
        }`}
      >
        Service fee waived
      </div>
    </Tooltip>
  );
};
